export default {
  title: 'Mobiilisovellus',
  fields: {
    name: 'Sovelluksen nimi',
  },
  buttons: {
    save: 'Tallenna',
  },
};
